/** The background job kind that imports a day's snapshots into the orders' statuses. */
export const ORDER_SNAPSHOT_STATUS_IMPORT_KIND = "importOrderStatuses";

const toCount = (value: unknown): number => {
  if (typeof value === "number") return value;
  return 0;
};

/** What a finished status import wrote, from its result — e.g. "TOE 41,188 · Toll 3,891 · eStore 19,292 written". */
export const toOrderSnapshotStatusImportSummary = (result: unknown): string => {
  const value = result as {
    toe?: { written?: unknown };
    threePl?: { toll?: { written?: unknown }; estore?: { written?: unknown } };
  } | null;
  const toe = toCount(value?.toe?.written);
  const toll = toCount(value?.threePl?.toll?.written);
  const estore = toCount(value?.threePl?.estore?.written);
  return `TOE ${toe.toLocaleString()} · Toll ${toll.toLocaleString()} · eStore ${estore.toLocaleString()} written`;
};
